import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useGetAllNotificationQuery } from "../redux/api/notificationApi";

export default function useNotification() {
  const [notification, setNotifications] = useState([]);
  const { agencyId } = useSelector((state) => state.auth);
  const { data } = useGetAllNotificationQuery(agencyId);
  useEffect(() => {
    if (data) {
      setNotifications(data);
    }
  }, [data]);

  useEffect(() => {
    if (!window.$ || !window.$.hubConnection) {
      console.error("SignalR client library not loaded");
      return;
    }

    const connection = window.$.hubConnection("https://data.realtorscrm.com/signalr", {
      qs: {
        id: agencyId,
        type: "2",
        token: localStorage.getItem("token"),
      },
    });

    const hub = connection.createHubProxy("notifcationHub");

    // 📩 Real-time notification
    hub.on("receiveNotification", (data) => {
      setNotifications((prev) => [
        ...prev,
        {
          description: data.message,
          notificationId: data.notificationId,
          readDate: null,
          receiverId: agencyId,
          receiverType: 2,
          sendDate: new Date().toISOString(),
          senderId: data.senderId || agencyId,
          senderType: 2,
          status: 0,
        },
      ]);
    });

    // ⚠️ Overdue lead alert
    hub.on("notifyOverdueLeadagc", (message) => {
        // console.log("⚠️ SignalR notifyOverdueLeadagc message:", message);

      setNotifications((prev) => [
        ...prev,
        {
          description: message,
          notificationId: notification.notificationId, // ✅ unique per message
          readDate: null,
          receiverId: agencyId,
          receiverType: 2,
          sendDate: new Date().toISOString(),
          senderId: agencyId,
          senderType: 2,
          status: 0,
        },
      ]);
    });

    connection
      .start()
      .done(() => console.log("✅ Connected to SignalR"))
      .fail((err) => console.error("❌ SignalR connection error:", err));

    return () => {
      connection.stop();
    };
  }, [agencyId]);

  return notification;
}
